// store/store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import counterReducer from './slices/counterSlice';
import modeReducer from './slices/modeSlice';
import authReducer from './slices/authSlice';
import rangoReducer from './slices/rangoSlice';
import coinsReducer from './slices/coinsSlice';
import walletReducer from './slices/walletSlice';
import toastReducer from './slices/toastSlice';

const appReducer = combineReducers({
    counter: counterReducer,
    mode: modeReducer,
    auth: authReducer,
    rango: rangoReducer,
    coins: coinsReducer,
    wallet: walletReducer,
    toast: toastReducer,
});

const rootReducer = (state, action) => {
    // When the user logs out, we want to clear out the entire redux state
    if (action.type === 'auth/logoutImmediate') {
        state = undefined;
    }
    return appReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
});
